import React from "react"
import { ProfessionItem } from "./professionItem"

export const ProfessionList = () => {

    const [list] = React.useState([
        {
            active:true,
            title:'Aerospace',
            children:[
                { title:'Aeronautical engineer' },
                { title:'Aircraft designer' },
                { title:'Aircraft mechanic' },
                { title:'Aviation manager' },
                { title:'Pilot' },
            ],
        },
        { title:'Agriculture',  children:[
            { title:'Agronomist' },
            { title:'Farmer' },
            { title:'Food inspector' },
            { title:'Landscape designer' },
            { title:'Wildlife biologist' },
        ] },
        { title:'Computer and technology' },
        { title:'Energy' },
        { title:'Manufacturing' },
        { title:'Education' },
        { title:'Finance and economic' },
        { title:'Entertainment' },
        { title:'Food and beverage' },
        { title:'Health care' },
        { title:'Hospitality' },
        { title:'Pharmaceutical' },
        { title:'Telecommunication' },
    ])

 
    return (
        <ul className="category_lists">
            { list?.length>0 && list.map((item,i)=>(
                <ProfessionItem item={item} key={`profession-${i}`} index={i} />
            ))}
        </ul>
    )
}


